var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-cases.2bd9d750.png","uri@2x": __webpack_public_path__ + "icon-cases.7b01c793.png","uri@3x": __webpack_public_path__ + "icon-cases.39c22233.png",
    width: 32,
    height: 28
});